import React, { memo, useMemo } from 'react';
import cx from 'classnames';

import ImageCheckbox from '../imageCheckbox/ImageCheckbox';

import { RESPONSE, DeviceClassMap } from '../../js/_constants';
import { parseDealershipTitle } from '../../js/helpers';

import './DealershipDevicesSelector.scss';
import {
    type DealershipWithFullDevices,
    type DeviceWithIsSelected
} from '../deviceAssignmentModal/DeviceAssignmentModal';

type SelectItemProps = {
    name: string;
    label: string;
    isSelected: boolean;
    deviceClass: string;
    onClick: () => void;
};

type DealershipDevicesSelectorProps = {
    option: DealershipWithFullDevices;
    onSelect: (option: DeviceWithIsSelected, id: string) => void;
    isAllSelected: boolean;
    onSelectAll: () => void;
    onDeselectAll: () => void;
    dealerId: string;
};

export const SelectItem = memo(({ 
    name,
    label,
    isSelected,
    deviceClass,
    onClick
}: SelectItemProps) => (
    <div className="select-item">
        <ImageCheckbox name={name} check={isSelected} label={label} onCheck={onClick} />
        {deviceClass === DeviceClassMap['3D'] ? '3D' : '2D'}
    </div>
));

const DealershipDevicesSelector = ({
    option,
    onSelect,
    isAllSelected,
    onSelectAll,
    onDeselectAll,
    dealerId
}: DealershipDevicesSelectorProps) => {
    const hasDevices = option.devices.length > 0;
    const dealershipLabel = useMemo(() => parseDealershipTitle(option), [option]);

    return (
        <div
            className={cx('b-dealership-devices-selector', {
                'is-disabled': !hasDevices
            })}
        >
            <ImageCheckbox
                className="select-all-button"
                key="selected_from_playlist"
                name={`select-all-${dealershipLabel}`}
                label={dealershipLabel}
                check={isAllSelected && hasDevices}
                onCheck={isAllSelected ? onDeselectAll : onSelectAll}
            />
            {option.devices.map((device, index) => (
                <SelectItem
                    name={`select-item-${index + 1}-dealer-${dealerId}`}
                    key={device[RESPONSE.ID]}
                    deviceClass={device.deviceClass}
                    label={`${device.deviceNumber} - ${device.title}`}
                    isSelected={device.isSelected}
                    onClick={() => onSelect(device, dealerId)}
                />
            ))}
        </div>
    );
};

export default memo(DealershipDevicesSelector);
